var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFunctionalUpskilling(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 6.867l-5.708-1.153L33.142 0l-5.803 5.714c-7.971-4.52-18.053-2.449-23.6 4.85-5.547 7.3-4.853 17.58 1.625 24.066 6.478 6.486 16.746 7.18 24.037 1.627 7.29-5.554 9.36-15.648 4.844-23.628L40 6.867zm-12.433-.162h.133l.095-.2 4.757-4.762.95 4.762 4.757.952-4.756 4.762-.447.296.057.095-.438.428-4.756-.952-.951-4.762.599-.62zm-4.61 31.722A17.388 17.388 0 0035.72 21.639a17.417 17.417 0 00-2.15-8.315l-.59.59-5.212-1.037-9.218 9.228h-.39l-.267-.266v-.372l.143-.152 9.094-9.105-1.037-5.22.59-.59A17.355 17.355 0 005.851 9.582a17.407 17.407 0 00-2.438 20.956 17.361 17.361 0 0019.544 7.889z",
    fill: "url(#functional-upskilling_svg__paint0_linear_1329_24425)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.542 7.39l-4.351-1.58-1.578-4.398-5.902 5.932 1.023 5.117 5.053.815 5.755-5.885z",
    fill: "url(#functional-upskilling_svg__paint1_linear_1329_24425)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.91 25.587A11.98 11.98 0 0018.067 33v-.083A11.974 11.974 0 0028 27.554a12.017 12.017 0 001.077-11.252l-.092-.194-.35-.111-.553.268.166.387a11.09 11.09 0 01-3.116 12.84 11.043 11.043 0 01-13.173.714 11.086 11.086 0 01-4.482-12.428 11.06 11.06 0 0110.589-7.883c1.482.012 2.946.326 4.303.924l.184.073.35-.147.139-.351-.148-.342-.157-.064a11.964 11.964 0 00-13.16 2.458A12.015 12.015 0 006.91 25.587zm10.806-9.876h.194l.184-.259v-.397l-.304-.212h-.147a6.208 6.208 0 00-5.81 6.33 6.207 6.207 0 006.07 6.08 6.206 6.206 0 006.32-5.82v-.193l-.259-.286h-.617v.387a5.302 5.302 0 01-5.397 4.973 5.303 5.303 0 01-5.189-5.19 5.304 5.304 0 014.955-5.413z",
    fill: "url(#functional-upskilling_svg__paint2_linear_1329_24425)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.928 16.125l-.351-.11-.554.267.166.387a11.076 11.076 0 11-5.889-5.88l.185.075.35-.148.14-.35-.12-.342-.158-.065a12 12 0 106.35 6.36l-.12-.194z",
    fill: "url(#functional-upskilling_svg__paint3_linear_1329_24425)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.771 15h-.143A6.006 6.006 0 1024 21.372v-.188l-.25-.276h-.598v.375a5.131 5.131 0 11-5.452-5.444h.187l.24-.277v-.383L17.772 15z",
    fill: "url(#functional-upskilling_svg__paint4_linear_1329_24425)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__paint0_linear_1329_24425",
    x1: 0,
    y1: 40,
    x2: 40,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__paint1_linear_1329_24425",
    x1: 26.711,
    y1: 13.276,
    x2: 38.575,
    y2: 1.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__paint2_linear_1329_24425",
    x1: 6,
    y1: 33,
    x2: 30,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__paint3_linear_1329_24425",
    x1: 6,
    y1: 33,
    x2: 30,
    y2: 9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "functional-upskilling_svg__paint4_linear_1329_24425",
    x1: 12,
    y1: 27,
    x2: 24,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB77C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E95F48"
  })))));
}
export default __webpack_public_path__ + "fonts/functional-upskilling-de6d204479fd76fc1f23056ef840cdbe.svg";
export { SvgFunctionalUpskilling as ReactComponent };